import * as React from "react";
import { css } from "@emotion/react";
import v from "@/module/Utils/variable";
import f from "@/module/Utils/emotion";
import Util from "@/module/Utils/Util";

//Component
import Picture from "@/components/Atoms/Picture";

// Data
import text from "@/module/data/texts/common";

//Images
import IconLandScape from "@/images/common/icon_landscape.svg";

const Landscape: React.FC = () => {
  const wrapRef = React.useRef<HTMLDivElement>();
  const [device, setDevice] = React.useState<string | null>("pc");

  //Style
  const landScapeAction = css({
    [f.landscape()]: {
      display: "initial",
    },
  });

  const landScapeWrap = css(device !== "pc" ? landScapeAction : null, {
    display: "none",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    backgroundColor: "#C9161F",
    zIndex: 9999,
  });

  const landScapeInner = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "100%",
    height: "100%",
  });

  const landScapeImage = css({
    width: "150px",
  });

  const landScapeText = css({
    fontSize: "15px",
    marginTop: f.vw(60, v.spWidth),
    color: "#fff",
    whiteSpace: "nowrap",
  });

  const setWrapHeight = () => {
    wrapRef.current.style.height = `${window.innerHeight}px`;
  };

  React.useEffect(() => {
    setWrapHeight();
    window.addEventListener("resize", setWrapHeight);
    setDevice(Util.getDevice());
    return () => {
      window.removeEventListener("resize", setWrapHeight);
    };
  }, []);

  return (
    <div css={landScapeWrap} ref={wrapRef}>
      <div css={landScapeInner}>
        <div css={landScapeImage}>
          <Picture path={IconLandScape} alt={""} />
        </div>
        <p css={landScapeText}>{text.landscape}</p>
      </div>
    </div>
  );
};

export default Landscape;
